import { IconProps } from '.';

const RestartArrowIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="2em"
      height="2em"
      viewBox="0 0 58 58"
      fill="none"
    >
      <path
        d="M35.2266 25.1777L43.4432 29.3824L47.4213 20.9565"
        stroke={color || 'var(--color-ui-stroke-primary'}
        strokeWidth="2"
      />
      <path
        d="M43 29.5C43 22.0442 36.9558 16 29.5 16C22.0442 16 16 22.0442 16 29.5C16 36.9558 22.0442 43 29.5 43C33.3684 43 36.8568 41.3729 39.3182 38.7658"
        stroke={color || 'var(--color-ui-stroke-primary'}
        strokeWidth="2"
      />
    </svg>
  );
};

export default RestartArrowIcon;
